import { render, staticRenderFns } from "./viewar.vue?vue&type=template&id=c914a6d2&"
import script from "./viewar.vue?vue&type=script&lang=js&"
export * from "./viewar.vue?vue&type=script&lang=js&"
import style0 from "./viewar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports